import { TelnyxRTC } from '@telnyx/webrtc';
import type { IClientOptions } from '@telnyx/webrtc';
import type { CredentialArgs } from './types';

export class TelnyxRTCFactory {
  create(credentials: CredentialArgs, debug = false): TelnyxRTC {
    const config: IClientOptions = {
      ringbackFile: undefined,
      ringtoneFile: undefined,
      debug,
      login_token: credentials.token,
    };

    return new TelnyxRTC(config);
  }
}
